import React, { useEffect, useState, useRef } from "react";
import "./ChangePasswordTab.css";
import { Form, Input, Button, notification, Row, Col, Select, Switch, Popover, Space, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { ChangePasswordActionHandler } from "../../../../Redux/Actions/user/SettingsChangePassword";
import { QrgeneratorActionHandler } from '../../../../Redux/Actions/user/SettingsOrGenerator';
import { QrCodeVerifyActionHandler } from '../../../../Redux/Actions/user/SettingsOrCodeVerify';
import { SettingsUserProfileMraActionHandler } from '../../../../Redux/Actions/user/SettingsUserProfileMra';
import { UserProfileActionHandler } from '../../../../Redux/Actions/user/SettingsUserProfile';
import QRCode from 'qrcode.react';
import VerificationInput from 'react-verification-input';
import { MdKeyboardBackspace } from "react-icons/md";
import { is } from "date-fns/locale";
const { Option } = Select;

const ChangePasswordTab = () => {
  const dispatch = useDispatch();
  const targetRef = useRef();
  const [api, contextHolder] = notification.useNotification();
  const userChangePasswordData = useSelector((state) => state?.SettingsChangePasswordData);
  const [form] = Form.useForm();
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isEnabled, setIsEnabled] = useState(true);
  const [qrCodeData, setQrCodeData] = useState(false);
  const [isGeneratQr, setIsGeneratQr] = useState(false);
  const [isVerificationCodeOpen, setIsVerificationCodeOpen] = useState(false);
  const [verificationValue, setVerificationValue] = useState('');
  const [copied, setCopied] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const CodeData = useSelector(
    (state) => state?.SettingsOrGeneratorData?.mfasettings_data?.data?.code
  );
  const userProfileData = useSelector(
    (state) => state.SettingsUserProfileData
  );
  const [updateValue, setUpdateValue] = useState(userProfileData?.user_profile_data?.is_mfa_enabled);
  const mfaStatus = JSON.parse(localStorage.getItem('userDetails'));
  const token = localStorage.getItem('token');
  const [isMfaEnabled, setIsMfaEnabled] = useState(mfaStatus.is_mfa_enabled);
  const toggleCurrentPasswordVisibility = () => {
    setShowCurrentPassword(!showCurrentPassword);
  };
  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  const onChangePasswordFinish = async (values) => {
    try {
      dispatch(ChangePasswordActionHandler(values));
    } catch (error) {
      console.error("Error updating post:", error.response.data);
    }
  };
  //   const fetchData = async () => {
  //     try {
  //         dispatch(UserProfileActionHandler());
  //     } catch (error) {}
  // };
  const confirmPasswordValidator = (rule, value, callback) => {
    const newPassword = form.getFieldValue("newPassword");
    const currentPassword = form.getFieldValue("currentPassword");

    if (value && newPassword && value !== newPassword) {
      callback("The passwords do not match.");
    } else if (value === currentPassword) {
      callback("New password must be different from the current password.");
    } else {
      callback();
    }
  };
  const openNotificationWithIcon = (type) => {
    api[type]({
      message: userChangePasswordData?.change_password_data?.message,
    });
  };
  useEffect(() => {
    if (userChangePasswordData?.change_password_data?.message) {
      openNotificationWithIcon("success");
    }
  }, [userChangePasswordData?.change_password_data?.message]);


  const onQRCode = () => {
    setIsEnabled(true)
    setIsGeneratQr(!isGeneratQr);
    dispatch(QrgeneratorActionHandler());
  };
  useEffect(() => {
    setIsEnabled(false)
    setIsGeneratQr(false);
    if (CodeData) {
      const userDetails = JSON.parse(localStorage.getItem('userDetails'));
      const appName = process.env.REACT_APP_NAME || 'QuickAction';
      const generatedQrCodeData = `otpauth://totp/${encodeURIComponent(
        appName
      )}:${encodeURIComponent(
        userDetails.email
      )}?secret=${encodeURIComponent(
        CodeData
      )}&issuer=${encodeURIComponent(appName)}`;
      setQrCodeData(generatedQrCodeData);
    }
  }, [CodeData]);
  const handleCodeText = () => {
    setVerificationValue('');
    setQrCodeData(!qrCodeData);
    setIsVerificationCodeOpen(!isVerificationCodeOpen);
  };

  const handleVerificationChange = (value) => {
    setVerificationValue(value);
    if (errorMessage) setErrorMessage('');
  };

  useEffect(() => {
    if (mfaStatus.is_mfa_enabled === true) {
      setIsGeneratQr(true);
    }

  });
  const handleCopyClick = () => {
    const chatScreenContent = targetRef.current.innerText;
    if (chatScreenContent.trim() === '') {
      message.error('No text/Data to copy');
      return;
    }
    navigator.clipboard
      .writeText(chatScreenContent)
      .then(() => {
        setIsCopied(true);
        message.success('Copied to clipboard');
      })
      .catch((error) => {
        console.error('Error copying chat screen:', error);
        message.error('Error copying chat screen');
      });
  };
  const content = (
    <div>
      <h4>Can't scan image?</h4>
      <p>Enter the following into your app: </p>
      Code : &nbsp;
      <div className="popover bold"><span ref={targetRef}>{CodeData}</span> <img src='/images/copy.svg' className='output-img' alt='' onClick={handleCopyClick}
      />
      </div>
    </div>
  );

  const handleStatus = (values) => {
    setQrCodeData(false);
    setIsVerificationCodeOpen(false)
  }

  const handleSwitchChange = (checked) => {
    setIsMfaEnabled(checked);
    // setUpdateValue(!updateValue)
    const data = {
      is_mfa_enabled: checked,
      token: token,
    };
    try {
      dispatch(SettingsUserProfileMraActionHandler(data));
      setIsEnabled(!isEnabled)
      setTimeout(() => {
        setUpdateValue(!updateValue);
      }, 2000);
    } catch (error) {
      console.error("Error updating post:", error.response.data);
    }
  };
  const validateInput = () => {
    if (!verificationValue.trim()) {
      setErrorMessage('This field cannot be empty.');
      return false;
    }
    return true;
  };
  // const handleStatusUpdate = () => {

  //   setTimeout(() => {
  //     setUpdateValue(!updateValue);
  //   }, 2000);
  // }
  const onVerifyCodeFinish = () => {
    // event.preventDefault();
    const isValid = validateInput();
    if (!isValid) return;
    try {
      dispatch(QrCodeVerifyActionHandler(verificationValue, (error, data) => {
        if (error) {
            console.error('Error during verification:', error);
            return;
        }
        setIsVerificationCodeOpen(!isVerificationCodeOpen)
        setIsEnabled(!isEnabled)
        setTimeout(() => {
            setUpdateValue(!updateValue);
        }, 2000);
      }));
    } catch (error) {
      console.error('Error during verification:', error);
    }
  };
  return (
    <>
      {contextHolder}
      <Row>
        {isVerificationCodeOpen ? (
          <Col span={12}>
            <>
              <h5>Enter your verification code to continue.</h5>
              <div className='mfa-settings-main'>
                <Form
                  name='verification'
                  initialValues={{ code: '' }}
                  onFinish={onVerifyCodeFinish}>
                  <div className='Verification_input'>
                    <label>Verification Code</label>
                    <VerificationInput
                      value={verificationValue}
                      onChange={handleVerificationChange}
                    />
                    {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                  </div>
                  <Form.Item>
                    <Button
                      type='primary'
                      htmlType='submit'
                      block
                      className='submit_login-btn mfa-settings-marginTop-30'
                      // onClick={handleStatusUpdate}
                      >
                      Verify
                    </Button>
                    <h4 className="back verify" onClick={handleStatus}>
                      <MdKeyboardBackspace />
                      Back
                    </h4>
                  </Form.Item>
                </Form>
              </div>
            </>
          </Col>
        ) : null}
        {!qrCodeData && !isVerificationCodeOpen ? (
          <>
            <Col span={12}>
              <Form
                form={form}
                initialValues={{
                  currentPassword: "",
                  newPassword: "",
                  confirmNewPassword: "",
                }}
                onFinish={onChangePasswordFinish}
              >
                <div className="change-password-tabel">
                  <span className="mt-0 font-22">Change your password</span>
                  <div className="change-password-rectangle-parent4">
                    <label className="first-name">Current Password</label>
                    <Form.Item
                      name="currentPassword"
                      rules={[
                        { required: true, message: "Please input your Current Password!" },
                      ]}
                    >
                      <Input
                        className="group-child5"
                        placeholder="Enter your Current Password"
                        type={showCurrentPassword ? "text" : "password"}
                        suffix={
                          showCurrentPassword ? (
                            <EyeInvisibleOutlined onClick={toggleCurrentPasswordVisibility} />
                          ) : (
                            <EyeOutlined onClick={toggleCurrentPasswordVisibility} />
                          )
                        }
                      />
                    </Form.Item>
                  </div>
                  <div className="change-password-rectangle-parent4">
                    <label className="first-name">New Password</label>
                    <Form.Item
                      name="newPassword"
                      rules={[
                        { required: true, message: "Please input your New Password!" },
                      ]}
                    >
                      <Input
                        type={showNewPassword ? "text" : "password"}
                        className="group-child5"
                        placeholder="Enter your New Password"

                        suffix={
                          showNewPassword ? (
                            <EyeInvisibleOutlined onClick={toggleNewPasswordVisibility} />
                          ) : (
                            <EyeOutlined onClick={toggleNewPasswordVisibility} />
                          )
                        }
                      />
                    </Form.Item>
                  </div>
                  <div className="change-password-rectangle-parent4">
                    <label className="first-name">Confirm New Password</label>
                    <Form.Item
                      name="confirmNewPassword"
                      rules={[
                        { required: true, message: "Please input your Confirm New Password!" },
                        { validator: confirmPasswordValidator },
                      ]}
                    >
                      <Input
                        type={showConfirmPassword ? "text" : "password"}
                        className="group-child5"
                        placeholder="Enter your Confirm New Password"
                        suffix={
                          showConfirmPassword ? (
                            <EyeInvisibleOutlined onClick={toggleConfirmPasswordVisibility} />
                          ) : (
                            <EyeOutlined onClick={toggleConfirmPasswordVisibility} />
                          )
                        }
                      />
                    </Form.Item>
                  </div>

                  <div className="change-password-rectangle-parent4">
                    <Form.Item>
                      <Button htmlType="submit" className="change-password-add-favourite">
                        Change Password
                      </Button>
                    </Form.Item>
                  </div>
                </div>
              </Form>
            </Col>
            <Col span={12}>
              <div className="change-password-tabel change-password-tabel">
                <div className="change-password-rectangle-parent4">
                  <span className="mt-0 font-22">Multi-factor authentication <span className={`alert ${updateValue === true ? 'success' : 'error'}`}>{
                    updateValue === true ? 'Enabled' : 'Disabled'
                  }</span></span>
                  {updateValue === true ? null : (
                    <>
                      <p className="font-18">Keep your account extra secure with a second login step.</p>
                    </>
                  )}
                  {updateValue === true ? null : (
                    <>
                      <a className="error" onClick={onQRCode}>Manage two-step verification</a>
                    </>
                  )}

                  {updateValue === true ? (
                    <>

                      <div className="change-password-rectangle-parent4 mt-5">
                        <span className="font-22">Disable Multi-factor authentication</span>
                        <br />
                        <Space direction="vertical" className="mt-1">
                          <Switch checkedChildren="Yes" unCheckedChildren="No" defaultChecked={updateValue} onChange={handleSwitchChange} />
                        </Space>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            </Col>
          </>

        ) : isVerificationCodeOpen ? null :
          <>
            <Col span={12}>
              <h5>
                Scan this QR code with your verification app
              </h5>
              <div className='mfa-settings-qrcode-verifiction'>
                <QRCode value={qrCodeData} />
              </div>
              <p className='mfa-settings-qrcode-div-p'>
                Can’t scan the code?{' '}
                <Popover content={content} title="Title" trigger="click" className="click-me">
                  <Button>Click me</Button>
                </Popover>
              </p>
              <Row>
                <Col span={4}>
                  <Button onClick={handleCodeText} htmlType="submit" className="change-password-add-favourite">
                    Next
                  </Button>
                </Col>
                <Col span={6}>
                  <h4 className="back" onClick={handleStatus}>
                    <MdKeyboardBackspace />
                    Back
                  </h4>
                </Col>
              </Row>
            </Col>
          </>
        }


      </Row>

    </>

  );
};

export default ChangePasswordTab;
